import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import { useTranslation } from '@common/hooks/translation';

const getStrengthLevel = (password) => {
  let score = 0;
  if (!password) return -1;
  if (password?.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/\d/.test(password) || /[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 1) return 0; // Weak
  if (score === 2) return 1; // Fair
  return 2; // Good
};

const strengthLabels = ['WEAK', 'FAIR', 'GOOD'];
const strengthClasses = ['red', 'yellow', 'green'];

export const PasswordStrengthMeter = ({ password }) => {
  const level = getStrengthLevel(password);
  const label = strengthLabels[level];
  const barClass = strengthClasses[level];
  const t = useTranslation();
  return (
    <div className="strength-meter">
      <div className='bars-wrapper'>
        <div className="bars">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className={`bar ${i <= level ? barClass : 'inactive'}`}
            />
          ))}
        </div>
        <div className="label">{label}</div>
      </div>
      <div className="text">{t('Password must be at least')} <span className={`${level >= 0 &&  level < 2 ? 'not-acceptable' : ''}`}> {t('8 characters, 1 uppercase letter')}</span> {t('and 1 symbol')}</div>
    </div>
  );
};

PasswordStrengthMeter.propTypes = {
  password: PropTypes.string,
};
